import(/* webpackMode: "eager" */ "/builds/league2play/f0/apps/ttm/src/app/error.tsx")